'use strict';

require('../../style/index.less');

require('./index.less');

require('../../select/style');

require('../../input/style');


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/lib/pagination/style/index.js
// module id = 1166
// module chunks = 0